



































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import VCheckbox from "@/components/VCheckbox.vue";
import Throttler from "@/services/Throttler";

export type YearsSelectorRange = { [key: string]: boolean };

@Component({ components: { VCheckbox } })
export default class YearsSelector extends Vue {
  @Prop({ required: true }) readonly start!: number;
  @Prop({ required: true }) readonly end!: number;
  @Prop({ required: true }) readonly disabledYear!: number;
  @Prop({ default: () => null }) readonly value!: string[] | null;
  yearToDisable = 0;
  range: YearsSelectorRange = {};
  opened = false;
  private readonly throttler = new Throttler(100);

  mounted() {
    this.initRange();
  }

  close() {
    this.opened = false;
  }

  toggleOpen() {
    this.opened = !this.opened;
  }

  changeSelected(value: boolean, year: string) {
    this.range[year] = value;
  }

  @Watch("value")
  onValueChanged(value: string[] | null) {
    this.initRange();
    if (value) {
      value.forEach((year) => {
        this.range[year] = true;
      });
    }
  }

  @Watch("start")
  onStartChanged() {
    this.throttler.run(() => {
      this.initRange();
    });
  }

  @Watch("end")
  onEndChanged() {
    this.throttler.run(() => {
      this.initRange();
    });
  }

  @Watch("disabledYear")
  onDisableChanged() {
    this.throttler.run(() => {
      this.initRange();
    });
  }

  get years() {
    return this.range;
  }

  yearSelected(year: string): boolean {
    return this.range[year];
  }

  private initRange() {
    let start = this.start;
    let end = this.start;
    this.yearToDisable = this.disabledYear;
    if (this.start < this.end) {
      start = this.end;
    } else {
      end = this.end;
    }
    for (let year = start; year > end; year--) {
      this.range[`${year}`] = false;
    }
    if (this.value) {
      this.value.forEach((year) => {
        this.range[year] = true;
      });
    }
  }

  private notifySelected() {
    const payload: string[] = [];
    for (const key in this.range) {
      if (this.range[key]) {
        payload.push(key);
      }
    }
    this.$emit("input", payload);
    this.close();
  }
}
